//----------without redux-persist-----------
// import React, { useContext, useEffect } from "react";
// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
// import Products from './Products';
// import {responsive, topCollection, electronicCollection, homeImprovement} from './data'
// import './CarousalProduct.css'
// import { useCart } from '../AddToCart/CartContext';
// import CarousalOnly2Product from '../Only2ProductCarousal/CarousalOnly2Product';
// import { Link, NavLink} from 'react-router-dom';

// import { DataContext } from "./DataProvider";

// function CarouselProducts() {

//   const {homeImprovementData, electronicCollectionData, loading, loadingMore, loadMoreHomeImprovement, loadMoreElectronicCollection } = useContext(DataContext);
 
//   // Effect to automatically load more products when reaching the bottom of the page (optional)
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (entries[0].isIntersecting) {
//           loadMoreHomeImprovement();
//           loadMoreElectronicCollection();
//         }
//       },
//       { threshold: 1.0 }
//     );

//     const bottomHomeImprovement = document.getElementById("homeImprovement-bottom");
//     const bottomElectronicCollection = document.getElementById("electronicCollection-bottom");

//     if (bottomHomeImprovement) observer.observe(bottomHomeImprovement);
//     if (bottomElectronicCollection) observer.observe(bottomElectronicCollection);

//     return () => {
//       if (bottomHomeImprovement) observer.unobserve(bottomHomeImprovement);
//       if (bottomElectronicCollection) observer.unobserve(bottomElectronicCollection);
//     };
//   }, [loading, loadingMore]);



//   const { addToCart} = useCart();

//     const productlist1 = topCollection.map((item) => (
//         <Products
//           key={item.id}
//           id={item.id}
//           name={item.name}
//           imageUrl={item.imageUrl}
//           price={item.price}
//           description={item.description}
//           addToCart={addToCart}
//           quantity={item.quantity}
//         />
//       ));

//       // const productlist2 = electronicCollection.map((item) => (
//       const productlist2 = electronicCollectionData.map((item) => (
//         <Products
//           key={item.id}
//           id={item.id}
//           name={item.name}
//           imageUrl={item.imageUrl}
//           price={item.price}
//           description={item.description}
//           addToCart={addToCart}
//           quantity={item.quantity}
//         />
//       ));

//       // const productlist3 = homeImprovement.map((item) => (
//       const productlist3 = homeImprovementData.map((item) => (
//         <Products
//           key={item.id}
//           id={item.id}
//           name={item.name}
//           imageUrl={item.imageUrl}
//           price={item.price}
//           description={item.description}
//           addToCart={addToCart}
//           quantity={item.quantity}
//         />
//       ));


//   return (
//     <>
//       <div className='Part1'>

//         <div className="text-container">
//           <div className="horizontal-line"></div>
//           <h3>🔥 Top Collections 🔥</h3>
//           <div className="horizontal-line"></div>
//         </div>
        
//         <p style={{textAlign:'center', marginTop:'-2vmax', marginBottom:'2vmax', fontSize:'1.5vmax', color:'gray'}}>Everything you Need is already here 😍😍😍<NavLink to="/top_collections" className='view_all_top_collections_link'>View All</NavLink></p>
//         <Carousel responsive={responsive} keyBoardControl={true}>
//           {productlist1}
//         </Carousel>
        

//         <CarousalOnly2Product />


//         <div className="text-container" >
//           <div className="horizontal-line"></div>
//           <h3>🔥 Electronics Collection 🔥</h3>
//           <div className="horizontal-line"></div>
//         </div>
//         <NavLink to="/electronics" className='view_all_electronics_collection_link'>View All</NavLink>
        


//         {loading ? (
//         <p>Loading...</p>
//       ) : (

//         <Carousel responsive={responsive} keyBoardControl={true}>
//           {productlist2}
//         </Carousel>

//         )}
//         <div id="homeImprovement-bottom" style={{ height: "1px" }}></div>
//         {/* {loadingMore && <p>Loading more products...</p>} */}
//         {loadingMore}



//         <div className="text-container" >
//           <div className="horizontal-line"></div>
//           <h3>🔥 Home Improvement 🔥</h3>
//           <div className="horizontal-line"></div>
//         </div>
//         <NavLink to="/home_improvement" className='view_all_home_improvement_link'>View All</NavLink>
        


//         {loading ? (
//         <p>Loading...</p>
//       ) : (

//         <Carousel responsive={responsive} keyBoardControl={true}>
//           {productlist3}
//         </Carousel>

//          )}
//          <div id="electronicCollection-bottom" style={{ height: "1px" }}></div>
//          {/* {loadingMore && <p>Loading more products...</p>} */}
//          {loadingMore}



//       </div>
      
//       </>
//   )
// }
// export default CarouselProducts;






//----------with redux-persist---------
import React, { useContext, useEffect, useState } from "react";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Products from './Products';
import {responsive, topCollection, electronicCollection, homeImprovement} from './data'
import './CarousalProduct.css'
import { useCart } from '../AddToCart/CartContext';
import CarousalOnly2Product from '../Only2ProductCarousal/CarousalOnly2Product';
import { Link, NavLink} from 'react-router-dom';
import DataProvider, { DataContext } from "./DataProvider";
import { useSelector } from "react-redux";
import Skeleton from '@mui/material/Skeleton';
import ElectronicCollectionBanner from "../ImageSlider/ElectronicCollectionBanner";
import { BannerProvider } from "../ImageSlider/BannerProvider";
import { motion } from 'framer-motion'; // Import Framer Motion
import CartDrawer from "../AddToCart/CartDrawer";

function CarouselProducts() {

  const {loading, loadingMore, loadMoreHomeImprovement, loadMoreElectronicCollection, loadMoreTopCollection } = useContext(DataContext);
  

  const {homeImprovement}= useSelector(
  (state) => state.homeImprovement
  );
  const {electronicCollection}= useSelector(
  (state) => state.electronicCollection
  );
  const {topCollection}= useSelector(
  (state) => state.topCollection
  );
 
    // const {homeImprovement}= useSelector(
    //   (state) => state.homeImprovement
    //   );

    // State to control the cart drawer visibility
  const [isCartOpen, setIsCartOpen] = useState(false);

  // Function to open the cart drawer
  const handleAddToCart = () => {
    setIsCartOpen(true);
  };

    // Track whether the data has been loaded
  const [isDataLoaded, setIsDataLoaded] = useState(false);
    useEffect(() => {
      // Check if all collections have data and set the isDataLoaded flag
      if (
        homeImprovement.length > 0 &&
        electronicCollection.length > 0 &&
        topCollection.length > 0 
      ) {
        setIsDataLoaded(true);
      }
    }, [homeImprovement, electronicCollection, topCollection]);
    
  // Effect to automatically load more products when reaching the bottom of the page (optional)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMoreHomeImprovement();
          loadMoreElectronicCollection();
          loadMoreTopCollection();
        }
      },
      { threshold: 1.0 }
    );

    const bottomHomeImprovement = document.getElementById("homeImprovement-bottom");
    const bottomElectronicCollection = document.getElementById("electronicCollection-bottom");
    const bottomTopCollection = document.getElementById("topCollection-bottom");

    if (bottomHomeImprovement) observer.observe(bottomHomeImprovement);
    if (bottomElectronicCollection) observer.observe(bottomElectronicCollection);
    if (bottomTopCollection) observer.observe(bottomTopCollection);

    return () => {
      if (bottomHomeImprovement) observer.unobserve(bottomHomeImprovement);
      if (bottomElectronicCollection) observer.unobserve(bottomElectronicCollection);
      if (bottomTopCollection) observer.unobserve(bottomTopCollection);
    };
  }, [loading, loadingMore]);
  

  const { addToCart} = useCart();

    const productlist1 = topCollection.map((item) => (
      <motion.div
    key={item.id}
    initial={{ opacity: 0, y: 20 }} // Initial animation state
    whileInView={{ opacity: 1, y: 0 }} // Animate when in view
    viewport={{ once: false }} // Animate only once
    transition={{ duration: 1 }} // Animation duration
  >
        <Products
          key={item.id}
          id={item.id}
          name={item.name}
          title={item.title}
          imageUrl={item.imageUrl}
          price={item.price}
          discountPrice={item.discountPrice}
          description={item.description}
          addToCart={addToCart}
          quantity={item.quantity}
          onAddToCart={handleAddToCart} 
        />
        </motion.div>
      ));
      const productlist2 = electronicCollection.map((item) => (
        <motion.div
        key={item.id}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 1 }}
      >
        <Products
          key={item.id}
          id={item.id}
          name={item.name}
          title={item.title}
          imageUrl={item.imageUrl}
          price={item.price}
          discountPrice={item.discountPrice}
          description={item.description}
          addToCart={addToCart}
          quantity={item.quantity}
          onAddToCart={handleAddToCart} 
        />
        </motion.div>
      ));
      const productlist3 = homeImprovement.map((item) => (
        <motion.div
    key={item.id}
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: false }}
    transition={{ duration: 1 }}
  >
        <Products
          key={item.id}
          id={item.id}
          name={item.name}
          title={item.title}
          imageUrl={item.imageUrl}
          price={item.price}
          discountPrice={item.discountPrice}
          description={item.description}
          addToCart={addToCart}
          quantity={item.quantity}
          onAddToCart={handleAddToCart} 
        />
        </motion.div>
      ));


      const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    // breakpoint: { max: 4000, min: 1024 },
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
    slidesToSlide: 5,
    partialVisibilityGutter: 40, // Agle items 40 pixels tak partially visible honge
  },
  desktop: {
    // breakpoint: { max: 1024, min: 800 },
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 3,
    partialVisibilityGutter: 30, // Agle items 30 pixels tak partially visible honge
  },
  superLargeTablet: {
    // breakpoint: { max: 800, min: 464 },
    breakpoint: { max: 1024, min: 600 },
    items: 4,
    slidesToSlide: 3,
    partialVisibilityGutter: 20, // Agle items 20 pixels tak partially visible honge
  },

  tablet: {
    // breakpoint: { max: 800, min: 464 },
    breakpoint: { max: 600, min: 464 },
    items: 3,
    slidesToSlide: 3,
    partialVisibilityGutter: 20, // Agle items 20 pixels tak partially visible honge
  },
  
  mobile: {
    // breakpoint: { max: 464, min: 0 },
    breakpoint: { max: 464, min: 0 },
    items: 2,
    slidesToSlide: 2,
    partialVisibilityGutter: 10, // Agle items 10 pixels tak partially visible honge
  }
};

  return (
    <>
      <motion.div className='product-collection-container'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}>

        <div className="text-container">
          <div className="horizontal-line"></div>
          <h3>⌚ Classic & Smart Watches</h3>
          <div className="horizontal-line"></div>
        </div>
        
        <p style={{textAlign:'center', marginTop:'-2vmax', marginBottom:'1.8rem', fontSize:'1.5vmax', color:'gray'}}>Where elegance meets everyday style.<NavLink to="/top_collections" className='view_all_top_collections_link'>View All</NavLink></p>
        
        {loading && !isDataLoaded ? (
        <Carousel responsive={responsive} keyBoardControl={true}>
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton key={index} variant="rectangular" width={'90%'} height={200} />
            ))}
          </Carousel>
      ) : (
        <Carousel responsive={responsive} keyBoardControl={true}>
          {productlist1}
        </Carousel>

        )}
        <div id="topCollection-bottom" style={{ height: "1px" }}></div>
        {loadingMore}

        <DataProvider> 
          <CarousalOnly2Product />
        </DataProvider>

        <div className='collection-banner-container'>
        <BannerProvider collectionName="collectionBanner">
          <ElectronicCollectionBanner />
        </BannerProvider>
        </div>

        <div className="text-container" >
          <div className="horizontal-line"></div>
          <h3>💰 Carry in Style Wallets</h3>
          <div className="horizontal-line"></div>
        </div>
        <NavLink to="/electronics" className='view_all_electronics_collection_link'>View All</NavLink>
        
        {loading && !isDataLoaded ? (
        <Skeleton variant="rectangular" width={'99%'} height={200} />
      ) : (
        <Carousel responsive={responsive} keyBoardControl={true}>
          {productlist2}
        </Carousel>
        
        )}
        <div id="electronicCollection-bottom" style={{ height: "1px" }}></div>
        {loadingMore}

        <div className="text-container" >
          <div className="horizontal-line"></div>
          <h3>💅🏼 Glow & Glam Cosmetics</h3>
          <div className="horizontal-line"></div>
        </div>
        <NavLink to="/home_improvement" className='view_all_home_improvement_link'>View All</NavLink>
        
        {loading && !isDataLoaded ? (
        <Skeleton variant="rectangular" width={'99%'} height={200} />
      ) : (
        <Carousel responsive={responsive} keyBoardControl={true}>
          {productlist3}
        </Carousel>

         )}
         <div id="homeImprovement-bottom" style={{ height: "1px" }}></div>
         {loadingMore}

         </motion.div>
         <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />     
      </>
  )
}
export default CarouselProducts;











//-------------original code------------
// import React, { useContext, useEffect } from "react";
// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';
// import Products from './Products';
// import {responsive, topCollection, electronicCollection, homeImprovement} from './data'
// import './CarousalProduct.css'
// import { useCart } from '../AddToCart/CartContext';
// import CarousalOnly2Product from '../Only2ProductCarousal/CarousalOnly2Product';
// import { Link, NavLink} from 'react-router-dom';


// function CarouselProducts() {

//   const { addToCart} = useCart();

//     const productlist1 = topCollection.map((item) => (
//         <Products
//           key={item.id}
//           id={item.id}
//           name={item.name}
//           imageUrl={item.imageUrl}
//           price={item.price}
//           description={item.description}
//           addToCart={addToCart}
//           quantity={item.quantity}
//         />
//       ));

//       const productlist2 = electronicCollection.map((item) => (
//         <Products
//           key={item.id}
//           id={item.id}
//           name={item.name}
//           imageUrl={item.imageUrl}
//           price={item.price}
//           description={item.description}
//           addToCart={addToCart}
//           quantity={item.quantity}
//         />
//       ));

//       const productlist3 = homeImprovement.map((item) => (
//         <Products
//           key={item.id}
//           id={item.id}
//           name={item.name}
//           imageUrl={item.imageUrl}
//           price={item.price}
//           description={item.description}
//           addToCart={addToCart}
//           quantity={item.quantity}
//         />
//       ));


//   return (
//     <>
//       <div className='Part1'>

//         <div className="text-container">
//           <div className="horizontal-line"></div>
//           <h3>🔥 Top Collections 🔥</h3>
//           <div className="horizontal-line"></div>
//         </div>
        
//         <p style={{textAlign:'center', marginTop:'-2vmax', marginBottom:'2vmax', fontSize:'1.5vmax', color:'gray'}}>Everything you Need is already here 😍😍😍<NavLink to="/top_collections" className='view_all_top_collections_link'>View All</NavLink></p>
//         <Carousel responsive={responsive} keyBoardControl={true}>
//           {productlist1}
//         </Carousel>
        

//         <CarousalOnly2Product />


//         <div className="text-container" >
//           <div className="horizontal-line"></div>
//           <h3>🔥 Electronics Collection 🔥</h3>
//           <div className="horizontal-line"></div>
//         </div>
//         <NavLink to="/electronics" className='view_all_electronics_collection_link'>View All</NavLink>
//         <Carousel responsive={responsive} keyBoardControl={true}>
//           {productlist2}
//         </Carousel>

//         <div className="text-container" >
//           <div className="horizontal-line"></div>
//           <h3>🔥 Home Improvement 🔥</h3>
//           <div className="horizontal-line"></div>
//         </div>
//         <NavLink to="/home_improvement" className='view_all_home_improvement_link'>View All</NavLink>
//         <Carousel responsive={responsive} keyBoardControl={true}>
//           {productlist3}
//         </Carousel>

//       </div>
      
//       </>
//   )
// }
// export default CarouselProducts;